export default "__VITE_ASSET___Z0dJrVo__"